// extracted by mini-css-extract-plugin
export default {"step":"Step_step--Yoj","stepTitle":"Step_stepTitle--jab","stepIcon":"Step_stepIcon--o1p"};